import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCloudSun,
  faTemperatureHigh,
  faWind,
  faTint,
  faMapMarkedAlt,
  faList,
  faExpand,
  faXmark
} from "@fortawesome/free-solid-svg-icons";

// 🔒 Move to env later
const OPEN_WEATHER_KEY = "YOUR_OPENWEATHER_API_KEY";

export default function OmniScanWeatherPanel({ building }) {

  const [view, setView] = useState("map");      // map | details
  const [mapExpanded, setMapExpanded] = useState(false);

  // Leeds for now – wire lat/lon later
  const mapSrc =
    `https://openweathermap.org/weathermap?basemap=map&cities=true&layer=clouds&lat=53.8008&lon=-1.5491&zoom=9&appid=${OPEN_WEATHER_KEY}`;

  return (
    <>
      {/* =========================
         PANEL CONTENT
      ========================= */}
      <div
        style={{
          padding: "14px",
          margin: "20px",
          borderRadius: "18px",
          background:
            "linear-gradient(180deg, rgba(255,255,255,0.06), rgba(255,255,255,0.02))",
          border: "1px solid rgba(255,255,255,0.08)",
          boxShadow: "inset 0 0 14px rgba(0,0,0,0.6)",
          display: "flex",
          flexDirection: "column",
          height: "360px",
          color: "#e6ebf3"
        }}
      >

        {/* Weather hero */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "14px",
            padding: "12px",
            borderRadius: "14px",
            background:
              "linear-gradient(180deg, rgba(20,26,36,0.9), rgba(10,14,20,0.9))",
            marginBottom: "10px"
          }}
        >
          <FontAwesomeIcon icon={faCloudSun} size="2x" color="#5fa8ff" />
          <div>
            <div style={{ fontSize: "22px", fontWeight: 800 }}>18°C</div>
            <div style={{ fontSize: "12px", opacity: 0.75 }}>
              {building?.location || building?.name} • Partly Cloudy
            </div>
          </div>
        </div>

        {/* Main area */}
        <div style={{ flex: 1, minHeight: 0 }}>

          {view === "map" && (
            <div
              style={{
                height: "100%",
                borderRadius: "14px",
                overflow: "hidden",
                border: "1px solid rgba(255,255,255,0.08)",
                boxShadow: "0 8px 20px rgba(0,0,0,0.45)"
              }}
            >
              <iframe
                title="Weather Map"
                src={mapSrc}
                style={{ width: "100%", height: "100%", border: "none" }}
              />
            </div>
          )}

          {view === "details" && (
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "10px"
              }}
            >
              <Metric icon={faTemperatureHigh} label="Feels Like" value="16°C" />
              <Metric icon={faWind} label="Wind" value="12 mph" />
              <Metric icon={faTint} label="Humidity" value="68%" />
              <MetricWide
                icon={faCloudSun}
                label="Conditions"
                value="Partly Cloudy"
              />
            </div>
          )}

        </div>

        {/* Buttons */}
        <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>

          <ActionButton
            icon={view === "map" ? faList : faMapMarkedAlt}
            label={view === "map" ? "Show details" : "Show map"}
            onClick={() => setView(view === "map" ? "details" : "map")}
            secondary
          />

          {view === "map" && (
            <ActionButton
              icon={faExpand}
              label="Expand"
              onClick={() => setMapExpanded(true)}
            />
          )}

        </div>
      </div>

      {/* =========================
         FULL MAP MODAL
      ========================= */}
      {mapExpanded && (
        <>
          {/* Backdrop */}
          <div
            onClick={() => setMapExpanded(false)}
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,0.75)",
              zIndex: 30000
            }}
          />

          {/* Modal */}
          <div
            style={{
              position: "fixed",
              top: "90px",
              left: "30px",
              right: "30px",
              bottom: "30px",
              background:
                "linear-gradient(180deg, #0f141c, #070a10)",
              borderRadius: "20px",
              boxShadow: "0 30px 90px rgba(0,0,0,0.9)",
              zIndex: 30000001,
              overflow: "hidden"
            }}
          >
            {/* Close */}
            <div
              onClick={() => setMapExpanded(false)}
              style={{
                position: "absolute",
                top: "14px",
                right: "16px",
                width: "36px",
                height: "36px",
                borderRadius: "50%",
                background: "rgba(255,255,255,0.08)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                zIndex: 10
              }}
            >
              <FontAwesomeIcon icon={faXmark} />
            </div>

            <iframe
              title="Expanded Weather Map"
              src={mapSrc}
              style={{ width: "100%", height: "100%", border: "none" }}
            />
          </div>
        </>
      )}
    </>
  );
}

/* =========================
   UI helpers
========================= */

function ActionButton({ icon, label, onClick, secondary }) {
  return (
    <button
      onClick={onClick}
      style={{
        flex: 1,
        padding: "12px",
        borderRadius: "14px",
        border: "none",
        background: secondary
          ? "linear-gradient(180deg, #1b2432, #111822)"
          : "linear-gradient(180deg, #4da3ff, #2b6fe3)",
        color: "#fff",
        fontWeight: 800,
        fontSize: "13px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
        boxShadow: secondary
          ? "inset 0 0 0 1px rgba(255,255,255,0.08)"
          : "0 8px 18px rgba(0,0,0,0.45)"
      }}
    >
      <FontAwesomeIcon icon={icon} />
      {label}
    </button>
  );
}

function Metric({ icon, label, value }) {
  return (
    <div
      style={{
        padding: "12px",
        borderRadius: "12px",
        background:
          "linear-gradient(180deg, rgba(255,255,255,0.08), rgba(255,255,255,0.02))",
        border: "1px solid rgba(255,255,255,0.08)",
        color: "#e6ebf3"
      }}
    >
      <FontAwesomeIcon icon={icon} color="#7fb7ff" />
      <div style={{ fontSize: "11px", marginTop: "4px", opacity: 0.7 }}>
        {label}
      </div>
      <div style={{ fontWeight: 800 }}>{value}</div>
    </div>
  );
}

function MetricWide({ icon, label, value }) {
  return (
    <div
      style={{
        gridColumn: "1 / -1",
        padding: "12px",
        borderRadius: "12px",
        background:
          "linear-gradient(180deg, rgba(255,255,255,0.08), rgba(255,255,255,0.02))",
        border: "1px solid rgba(255,255,255,0.08)",
        color: "#e6ebf3"
      }}
    >
      <FontAwesomeIcon icon={icon} color="#7fb7ff" />
      <div style={{ fontSize: "11px", marginTop: "4px", opacity: 0.7 }}>
        {label}
      </div>
      <div style={{ fontWeight: 700 }}>{value}</div>
    </div>
  );
}
